import { Box } from "@components/Box"
import IconDanger from "@components/ui/icons/IconDanger"
import IconDeselect from "@components/ui/icons/IconDeselect"
import { LoadingPulse } from "@components/ui/LoadingPulse"
import { Text } from "@components/ui/typograhpy/Text"
import { EnhancedImageStatus } from "@generated"
import React, { FC } from "react"
import { useCancelEnhancementById } from "../../../../hooks/use-cancel-enhancement-by-id"
import { StatusFinished } from "./StatusFinished"

type EnhancementStatusIndicatorProps = {
  id: string
  status: EnhancedImageStatus
  uploadProgress: number
  mimeType?: string
}

export const EnhancementStatusIndicator: FC<
  EnhancementStatusIndicatorProps
> = ({ id, status, mimeType, uploadProgress }) => {
  const { cancelEnhancement } = useCancelEnhancementById(id)
  if (status === EnhancedImageStatus["Error"]) {
    return (
      <Box className="text-danger">
        <IconDanger size={20} />
      </Box>
    )
  }

  if (status === EnhancedImageStatus["Cancelled"]) {
    return (
      <Box className="flex items-center text-white">
        <Text variant="micro" className="mr-2 text-shade-400">
          Cancelled
        </Text>
      </Box>
    )
  }

  if (status === EnhancedImageStatus["Finished"]) {
    return <StatusFinished>Enhanced</StatusFinished>
  }

  if (status === EnhancedImageStatus["Queued"]) {
    return (
      <Box className="flex items-center text-white">
        <Text variant="micro" className="mr-2 text-shade-400">
          Waiting
        </Text>
        <span className="cursor-pointer" onClick={() => cancelEnhancement()}>
          <IconDeselect />
        </span>
      </Box>
    )
  }

  if (status === EnhancedImageStatus["Processing"]) {
    return (
      <Box className="flex items-center text-white">
        <Text variant="micro" className="mr-2 text-white">
          Enhancing
        </Text>
        {mimeType === "application/pdf" ? (
          <span className="cursor-pointer" onClick={() => cancelEnhancement()}>
            <IconDeselect />
          </span>
        ) : (
          <LoadingPulse />
        )}
      </Box>
    )
  }

  return null
}
